// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-header-header-header-blqby{margin-left:-50px;margin-right:-50px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "components-header-header-header-blqby"
};
module.exports = ___CSS_LOADER_EXPORT___;
